import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { YOUTUBE_API_URL } from "../utils/constants"
import { setPopularVideos } from '../utils/videoSlice'
import VideoCard from './VideoCard'
import { Link } from 'react-router-dom'

const VideoContainer = () => {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const dispatch = useDispatch()
  const cachedVideos = useSelector(store => store.video.popularVideos)

  useEffect(() => {
    if (cachedVideos) {
      setLoading(false)
      return
    }

    const getVideos = async () => {
      try {
        setLoading(true)
        setError(null)
        const p = await fetch(YOUTUBE_API_URL)
        const json = await p.json()
        const items = json.items || []
        dispatch(setPopularVideos(items))
      }
      catch (e) {
        console.error(e)
        setError("Failed to load videos. Please try again later.")
      }
      finally {
        setLoading(false)
      }
    }

    getVideos()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch])

  const videos = cachedVideos || []

  if (loading) return (
    <div className="flex justify-center items-center py-20">
      <div className="animate-spin h-10 w-10 border-4 border-gray-300 border-t-red-500 rounded-full"></div>
    </div>
  )

  if (error) return (
    <div className="flex justify-center items-center py-20 text-red-500">
      <p>{error}</p>
    </div>
  )

  if (videos.length === 0) return (
    <div className="flex justify-center items-center py-20 text-gray-500">
      <p>No videos found.</p>
    </div>
  )

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4 px-2 sm:px-4">
      {videos.map(video =>
      (
        <Link to={"/watch?v=" + video.id} key={video.id}>
          <VideoCard info={video} />
        </Link>
      ))}
    </div>
  )
}

export default VideoContainer